var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.21606 13.1092C3.21606 8.2348 3.21606 5.7976 4.66014 4.28332C6.10423 2.76904 8.42844 2.76904 13.0769 2.76904C17.7252 2.76904 20.0495 2.76904 21.4936 4.28332C22.9376 5.7976 22.9376 8.2348 22.9376 13.1092C22.9376 17.9835 22.9376 20.4207 21.4936 21.9351C20.0495 23.4493 17.7252 23.4493 13.0769 23.4493C8.42844 23.4493 6.10423 23.4493 4.66014 21.9351C3.21606 20.4207 3.21606 17.9835 3.21606 13.1092Z",
    stroke: "white",
    strokeWidth: 1.19577,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.67 13.1089C17.67 15.7457 15.613 17.8832 13.0754 17.8832C10.5379 17.8832 8.48077 15.7457 8.48077 13.1089C8.48077 10.472 10.5379 8.33447 13.0754 8.33447C15.613 8.33447 17.67 10.472 17.67 13.1089Z",
    stroke: "white",
    strokeWidth: 1.19577
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7018 7.27393H18.6917",
    stroke: "white",
    strokeWidth: 1.59436,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.59e69aca5f0a3996912336b2947465d9.svg";
export { ForwardRef as ReactComponent };